(function () {
  // Rewritten from the original jQuery bundle -- this theme never loads
  // jQuery, so the original initCollapsibleContent() threw
  // "$ is not defined" immediately and aborted before initGallery() (the
  // part that actually matters here, the left-hand crossfade gallery) ever
  // ran. initCollapsibleContent() itself targeted ".banner-with-popup__toggle"
  // elements, which this theme's markup doesn't use, so it's dropped
  // entirely rather than ported. Likewise the IntersectionObserver
  // ".observe-me" branch is dropped since our markup never adds that class
  // -- the gallery always starts its slideshow immediately.
  const startGallerySlideshow = (images) => {
    if (!images.length) return;

    if (images.length === 1) {
      images[0].classList.add("is-active");
      return;
    }

    const gallery = images[0].closest(".banner-with-popup__gallery");
    const speed = (parseFloat(gallery && gallery.dataset.speed) || 2) * 1000;
    let currentIndex = 0;

    images.forEach((img, i) => img.classList.toggle("is-active", i === 0));

    setInterval(() => {
      const nextIndex = (currentIndex + 1) % images.length;
      images[currentIndex].classList.remove("is-active");
      images[nextIndex].classList.add("is-active");
      currentIndex = nextIndex;
    }, speed);
  };

  const initGallery = () => {
    document.querySelectorAll(".banner-with-popup").forEach((item) => {
      if (item.dataset.gallerySlideshowInit === "true") return;
      item.dataset.gallerySlideshowInit = "true";

      const images = Array.from(item.querySelectorAll(".banner-with-popup__gallery--image-wrapper"));
      startGallerySlideshow(images);
    });
  };

  // The theme's shared <modal-opener>/<modal-dialog> custom elements (defined
  // in global.js) are supposed to handle the "View More" popup, but that
  // instance's click listener never fires -- modal.show() works fine when
  // called directly, so the dialog side is healthy, but ModalOpener's own
  // constructor logic isn't wiring up the click on this button for reasons
  // that don't reproduce outside the full minified bundle. Rather than
  // depend on that, wire the open/close behavior here directly: it only
  // needs to toggle the "open" attribute (the CSS transition/positioning is
  // untouched) and lock/unlock body scroll, so a small vanilla handler is
  // enough and doesn't fight with whatever global.js does or doesn't do.
  const initPopupModal = () => {
    document.querySelectorAll(".banner-with-popup").forEach((item) => {
      if (item.dataset.popupModalInit === "true") return;
      item.dataset.popupModalInit = "true";

      const openBtn = item.querySelector('[id^="ModalPopup-"]');
      const opener = openBtn ? openBtn.closest("modal-opener") : null;
      const modalSelector = opener ? opener.getAttribute("data-modal") : null;
      const modal = modalSelector ? document.querySelector(modalSelector) : null;
      if (!openBtn || !modal) return;

      const closeBtn = modal.querySelector('[id^="ModalClose-"]');

      const openModal = () => {
        modal.setAttribute("open", "");
        document.body.classList.add("overflow-hidden");
      };

      const closeModal = () => {
        modal.removeAttribute("open");
        document.body.classList.remove("overflow-hidden");
      };

      openBtn.addEventListener("click", openModal);
      if (closeBtn) closeBtn.addEventListener("click", closeModal);

      // Clicking the dimmed backdrop (i.e. the modal's outer wrapper itself,
      // not the sliding panel inside it) also closes it.
      modal.addEventListener("click", (event) => {
        if (event.target === modal) closeModal();
      });

      document.addEventListener("keyup", (event) => {
        if (event.key === "Escape" && modal.hasAttribute("open")) closeModal();
      });
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    initGallery();
    initPopupModal();
    document.addEventListener("shopify:section:load", function () {
      initGallery();
      initPopupModal();
    });
  });
})();
